import React from 'react';
import strings from 'strings';
import { Dialog } from 'components/shared/Dialog';
import {
    Button,
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core';
import { maxLength2000, maxLength50, minLength10, minLength5 } from 'tools/forms/validators';
import { FormProvider, useForm } from 'react-hook-form';
import TextFieldForm from '../../forms/TextFieldForm';
import { composeValidators } from '../../../tools/forms/validators';

function TemplateForm(props) {
    const {
        open,
        onClose,
        onSubmit,
        mode = "Create",
        loading,
        submitting,
    } = props;

    const methods = useForm();
    const { handleSubmit, reset } = methods;

    return (
        <Dialog open={open} fullWidth={true} maxWidth="sm">
            <DialogTitle>
                {mode} {strings.APPLICANT.UCCFILING.COLLATERAL_DESCRIPTION}
            </DialogTitle>
            {loading ? (
                <div className="loaderContainer">
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <DialogContent>
                        <FormProvider {...methods}>
                            <TextFieldForm
                                name='description'
                                variant={"outlined"}
                                label={strings.SETTINGS_FORM.TEMPLATE.NAME}
                                required
                                size='small'
                                fullWidth
                                className='mb-2 mt-2'
                                validate={composeValidators(minLength5, maxLength50)}
                            />
                            <TextFieldForm
                                name='templateText'
                                className='mb-2'
                                variant='outlined'
                                label={strings.SETTINGS_FORM.TEMPLATE.DESCRIPTION}
                                required size='small'
                                maxRows={20}
                                minRows={4}
                                multiline
                                fullWidth
                                validate={composeValidators(minLength10, maxLength2000)}
                            />
                        </FormProvider>
                    </DialogContent>
                </>
            )}

            <DialogActions>
                <Button color="primary" onClick={onClose}>
                    {strings.CANCEL}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(async (data) => {
                        onSubmit(data);
                        reset();
                    })}
                    disabled={loading || submitting}
                >
                    {strings.Save}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateForm